export const numberSorter = (a: any, b: any) => {
  const numA = typeof a === 'number' ? a : parseFloat(a);
  const numB = typeof b === 'number' ? b : parseFloat(b);
  return numA - numB;
};

export const stringSorter = (a: any, b: any) => {

  const strA = typeof a === 'string' ? a : String(a);
  const strB = typeof b === 'string' ? b : String(b);
  return strA.localeCompare(strB);
};